import { Fragment, useMemo } from 'react';

import { Box, Flex, Heading, Text } from '@chakra-ui/react';

export type MentorStatsSectionProps = {
  stats: {
    title: string;
    value: string;
  }[];
};

export function MentorStatsSection({ stats }: MentorStatsSectionProps) {
  return (
    <Box bgColor='none' margin={{ base: '40px 0 0', md: '80px 0 0' }}>
      <Flex
        alignItems={{ base: 'center', lg: 'normal' }}
        bg='accent.sky.100'
        borderBottomLeftRadius='24px'
        borderBottomRightRadius='base'
        borderTopLeftRadius='base'
        borderTopRightRadius='24px'
        flexDirection={{ base: 'column', lg: 'row' }}
        gap={{ base: '40px', md: '40px' }}
        justifyContent='space-between'
        p='32px 85px'
        textAlign={{ base: 'center', lg: 'left' }}
      >
        {stats.map((stat, i) => (
          <Fragment key={stat.title}>
            <Stat stat={stat} />
            {i !== stats.length - 1 && (
              <Box
                bg='white'
                display={{ base: 'none', md: 'block' }}
                height={{ base: '2px', lg: 'unset' }}
                width={{ base: '100%', lg: '2px' }}
              />
            )}
          </Fragment>
        ))}
      </Flex>
    </Box>
  );
}

function Stat({ stat }: { stat: MentorStatsSectionProps['stats'][number] }) {
  // Given values like: 16.9M+, 1.2K+, 90% - create 2 arrays, the first containing the numbers, and the second containing the rest
  const { numbers, rest } = useMemo(() => {
    const [number, ...restOfStat] = stat.value.split(/(M|K|%)/);

    return {
      numbers: number,
      rest: restOfStat.join(''),
    };
  }, [stat]);

  return (
    <Flex key={stat.title} flexDirection='column' gap='8px' width='200px'>
      <Heading as='div' color='blue.500' fontWeight='500' size='marketing-5xl'>
        {numbers}
        <Heading as='span' fontWeight='500' size='marketing-4xl'>
          {rest}
        </Heading>
      </Heading>
      <Text size='label'>{stat.title}</Text>
    </Flex>
  );
}
